import { InformationCircleIcon } from "@heroicons/react/20/solid";
import { twMerge } from "tailwind-merge";

export function ImportantText({
  children,
  className,
}: {
  children: React.ReactNode;
  className?: string;
}) {
  return (
    <div className={twMerge("rounded-md bg-primaryLight p-4", className)}>
      <div className="flex">
        <div className="flex-shrink-0">
          <InformationCircleIcon
            className="h-5 w-5 text-primary"
            aria-hidden="true"
          />
        </div>
        <div className="ml-3 flex-1">
          <p className="text-sm text-gray-900">{children}</p>
        </div>
      </div>
    </div>
  );
}
